var $6c33509d5190e7a2$exports = {};
// This file is still present because Monolith requires it to be here.
// Can  be cleaned up as soon as Monolith is adjusted.


//# sourceMappingURL=global-fragment-navigation-skeleton-empty.a9320f55.js.map
